import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  text: 'Llevaba años sintiéndome agotada por una compañera de trabajo. El Módulo 3 fue revelador. Por primera vez entendí qué me pasaba realmente cada vez que hablábamos.',
  name: 'Marcela G.',
  city: 'Córdoba'
}, {
  initials: 'LP',
  text: 'Probé muchos libros de autoayuda. Este es distinto. Es práctico, claro y se nota que está pensado para aplicarlo de verdad. Lo recomiendo a todos mis amigos.',
  name: 'Laura P.',
  city: 'Rosario'
}, {
  initials: 'RM',
  text: 'El bonus de las 50 frases me salvó. Tengo un jefe muy difícil y antes me iba del trabajo agotada. Hoy salgo con la cabeza intacta.',
  name: 'Romina M.',
  city: 'Buenos Aires'
}];
export function QuickTestimonials() {
  return <section className="w-full bg-bg-soft py-14 md:py-20 px-4 border-y border-line" data-id="element-337" data-mp="274frr3a11nnf">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-5" data-id="element-338" data-mp="2c391qlq3uwiu">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08,
        duration: 0.5
      }} className="bg-white border border-line rounded-3xl p-6 shadow-sm" data-id="element-339" data-mp="2pqjw8ivbnyal" data-mpi={i}>
            <div className="flex items-center gap-3 mb-3" data-id="element-340" data-mp="220pfhq7vtpl2">
              <div className="w-11 h-11 rounded-full bg-rose text-white flex items-center justify-center font-bold font-serif text-sm" data-id="element-341" data-mp="2fr2mnqcy909c">
                {t.initials}
              </div>
              <div className="flex gap-0.5" data-id="element-342" data-mp="1n9ysqwl5dgot">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-rose text-rose" data-id="element-343" data-mp="1ibf2wl3fnkr6" data-mpi={j} />)}
              </div>
            </div>
            <p className="font-serif-italic text-ink leading-relaxed text-base mb-4" data-id="element-344" data-mp="3icdc8hs7yvn8">
              "{t.text}"
            </p>
            <div className="text-sm font-semibold text-ink" data-id="element-345" data-mp="3nan7esdy1w8u">
              {t.name}{' '}
              <span className="text-muted font-normal" data-id="element-346" data-mp="3s3q439e0plt9">— {t.city}</span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}